import { useQuery } from '@apollo/client';

import useCompanyContext from 'common/hooks/useCompanyContext';

import { SubscriptionPlanProfileDocument } from './subscriptionPlanProfile.gql';

const useSubscriptionPlanProfile = () => {
  const { companyProfileId } = useCompanyContext();

  if (!companyProfileId) {
    throw new Error(
      'companyProfileId is undefined in useSubscriptionPlanProfileQuery',
    );
  }

  const { data, error, loading } = useQuery(SubscriptionPlanProfileDocument, {
    variables: { companyProfileId },
  });

  return {
    canAccessPhoneSupport: data?.viewer.company.canAccessPhoneSupport,
    error,
    loading,
  };
};

export default useSubscriptionPlanProfile;
